<template>
  <router-link tag="div" class="item" :data-id="item.id" :to="{path:`/im/${encodeURIComponent(item.id)}`, query:$route.query}">
    <div class="avatar">
      <img :src="`./images/imavatars/${item.avatar}.png`" :alt="item.avatar"/>
      <div class="name">{{item.name}}</div>
    </div>
    <div class="row panel">
      <img class="thumb" v-if="item.thumb" :src="`./images/imfiles/${item.thumb}.jpg`" alt=""
        loading="lazy" @error="$event.target.style.display = 'none'">
      <div class="title">
        {{blank($pick(item.titles)) ? '—' : $pick(item.titles)}}
      </div>
      <div class="info">
        <div class="replies" :title="'replies: ' + item.replies">
          <img src="@/assets/im-replies.svg" alt="reply">
          {{item.replies}}
        </div>
        <LikeButton :pid="item.id" :count="item.likes"/>
      </div>
    </div>
  </router-link>
</template>

<script>
import LikeButton from '../LikeButton';

export default {
  name: 'Item',
  props: ['item'],
  components: { LikeButton },
  methods: {
    blank(s) { return !s || !String(s).replace(/[\s\u200b]/g, ''); }
  },
  mounted() {
    if (this.$route.hash==`#${this.item.id}`){
      this.$el.scrollIntoView();
    }
  }
}
</script>

<style lang="scss" scoped>
.list .item {
  cursor: pointer;
}
.item {
  display: flex;
  align-items: center;
  margin: 12px 18px 12px 8px;
  user-select: none;
  .avatar {
    min-width: 96px;
    max-width: 96px;
    text-align: center;
    @media screen and (max-width: 767px) {
      min-width: 72px;
      max-width: 72px;
    }
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      border: 2px solid var(--line);
      background: var(--surface);
      box-sizing: border-box;
      object-fit: cover;
    }
    .name {
      margin-top: 2px;
      font-size: .8em;
      color: var(--dim);
      word-break: break-all;
      line-height: 1.1;
    }
  }
  .row {
    flex: 1;
    min-width: 0;
    min-height: 68px;
    display: flex;
    align-items: center;
    padding: 6px 12px 6px 18px;
    box-sizing: border-box;
    transition: background .2s ease, box-shadow .2s ease;
    @media screen and (max-width: 767px) {
      flex-wrap: wrap;
      padding-left: 12px;
    }
  }
  &:hover .row {
    background: var(--panel-hi);
    box-shadow: 0 0 14px var(--line-dim);
  }
  .thumb {
    flex: none;
    width: 72px;
    height: 54px;
    margin-right: 18px;
    object-fit: cover;
    border: 1px solid var(--line-dim);
    background: var(--surface);
    @media screen and (max-width: 767px) { display: none; }
  }
  .title {
    flex: 1;
    min-width: 0;
    font-size: 1.25em;
    word-break: break-word;
    text-shadow: 0 1px 3px rgba(0, 0, 0, .6);
    @media screen and (max-width: 767px) {
      flex: 1 1 100%;
    }
  }
  .info {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-left: 12px;
    @media screen and (max-width: 767px) {
      margin-left: auto;
    }
    .replies {
      display: flex;
      align-items: center;
      gap: 5px;
      color: var(--dim);
      img {
        height: .85em;
        opacity: .7;
      }
    }
  }
}
</style>
